import { FunctionComponent } from "react";
import { grey } from "@mui/material/colors";

interface Props {
  color: string;
  country: string;
  percentage: number;
}

const SoloBar: FunctionComponent<Props> = ({ color, country, percentage }) => {
  return (
    <div
      style={{
        position: "relative",
        marginBottom: "4px",
      }}
    >
      {country}
      <span
        style={{
          position: "absolute",
          right: "10px",
          color: "black",
        }}
      >
        {percentage.toFixed(1)}%
      </span>
      <div
        style={{
          backgroundColor: grey[200],
          width: `100%`,
          height: "5px",
          borderRadius: "5px",
          position: "relative",
        }}
      >
        <div
          key={country}
          style={{
            backgroundColor: color,
            width: `${percentage}%`,
            height: "100%",
            position: "absolute",
            borderRadius: "5px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default SoloBar;
